import { render } from "./GrammarPage.vue?vue&type=template&id=c80e4e44&scoped=true"
import script from "./GrammarPage.vue?vue&type=script&lang=js"
export * from "./GrammarPage.vue?vue&type=script&lang=js"

import "./GrammarPage.vue?vue&type=style&index=0&id=c80e4e44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80e4e44"]])

export default __exports__